import { Component, OnInit, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { UserPassword, UserDetails } from '../../../../../models/user';
import { EventTrackerService, UserActionType, Page, TargetType } from '../../../../services/event-tracker/event-tracker.service';
import { UserService } from '../../../../services/user.service';
import { ModalService } from '../../../../services/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { AchooPopupComponent } from '../../../../core/achoo-popup/achoo-popup.component';
import { WebUtils } from '../../../../utils/web.utils';

@Component({
  selector: 'change-pwd',
  templateUrl: './change-pwd.component.html',
  styleUrls: ['./change-pwd.component.scss']
})
export class ChangePwdComponent implements OnInit {

  @ViewChild('ChangePwdNotificationPopup')
  public changePwdNotificationPopup: AchooPopupComponent;
  private _changePwdNotificationPopupRef;

  @Input() currentUserDetails: UserDetails;
  @Input() isUserDetailsChanged: boolean;

  @Output() afterUpdatePasswordCallback: EventEmitter<any> = new EventEmitter();

  public userPasswordForm: FormGroup;
  public userPasswordData: UserPassword = new UserPassword();
  public msgString: string;
  public isEmptyNewPwd: boolean;
  public isEmptyRepeatNewPwd: boolean;
  public isNotification: boolean;
  public isEmpty = false;
  public popupTitle: string;

  constructor(private eventTracker: EventTrackerService,
              private userService: UserService,
              private modalService: ModalService,
              private translate: TranslateService) { }

  ngOnInit() {
    this.userPasswordForm = new FormGroup({
      'oldPassword': new FormControl(this.userPasswordData.oldPassword),
      'newPassword': new FormControl(''),
      'repeatNewPassword': new FormControl('')
    });
  }

  get oldPassword() {
    return this.userPasswordForm.get('oldPassword');
  }

  onSubmit() {
    if (this.userPasswordData.oldPassword && this.userPasswordData.newPassWord && this.userPasswordData.repeatNewPassword) {
      this.isEmpty = false;
      this.updateUserPassword();
    } else {
      this.isEmpty = (!this.userPasswordData.oldPassword && this.userPasswordData.newPassWord && this.userPasswordData.repeatNewPassword) ||
                      (this.userPasswordData.oldPassword && !this.userPasswordData.newPassWord && !this.userPasswordData.repeatNewPassword) ? true : false;
    }
  }

  private updateUserPassword() {
    const oldPassword = this.userPasswordData.oldPassword;
    const newPassword = this.userPasswordData.newPassWord;
    this.userService.updatePassword(oldPassword, newPassword).subscribe((res) => {
      this.afterUpdatePasswordCallback.emit(true);
      if (!this.isUserDetailsChanged) {
        this.popupTitle = this.translate.instant('notification.success');
        this.msgString = this.translate.instant('account_settings.notification_msg.update_user_password_success');
        this.modalService.close(this._changePwdNotificationPopupRef);
        this._changePwdNotificationPopupRef = this.modalService.openMultipleModal(this.changePwdNotificationPopup, null);
      }
      this.userPasswordData = new UserPassword();
      this.sendUpdateUserEvent();
    }, (error) => {
      this.afterUpdatePasswordCallback.emit(false);
      this.popupTitle = this.translate.instant('notification.error');
      if (error.error.data === 'wrong_password') {
        this.msgString = this.translate.instant('account_settings.notification_msg.wrong_password');
        WebUtils.reportErrorToSentry('User provided incorrect password on password update', error);
      } else if (error.error.data === 'invalid_password') {
        this.msgString = this.translate.instant('account_settings.notification_msg.invalid_password');
        WebUtils.reportErrorToSentry('User provided incorrect password on password update', error);
      } else {
        this.msgString = this.translate.instant('account_settings.notification_msg.update_failed');
        WebUtils.reportErrorToSentry('Password update failed on Settings page', error);
      }
      this.modalService.close(this._changePwdNotificationPopupRef);
      this._changePwdNotificationPopupRef = this.modalService.openMultipleModal(this.changePwdNotificationPopup, null);
    });
  }

  private sendUpdateUserEvent() {
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.PROFILE, {
      id: this.currentUserDetails.id,
      name: this.currentUserDetails.firstName + ' ' + this.currentUserDetails.lastName,
      type: TargetType.USER
    }, {
      action: UserActionType.UPDATE,
    }, undefined, null, null);
  }

  get isValidNewPwd() {
    return (this.userPasswordData.repeatNewPassword && this.userPasswordData.newPassWord && (this.userPasswordData.repeatNewPassword === this.userPasswordData.newPassWord))
    || (this.userPasswordData.repeatNewPassword === '' && this.userPasswordData.newPassWord === '');
  }

  public hasFormChanged() {
    return this.userPasswordForm.dirty || (this.userPasswordForm.value.oldPassword !== ''
            && this.userPasswordForm.value.newPassword !== ''
            && this.userPasswordForm.value.repeatNewPassword !== '');
  }

  public hasFormEmpty() {
    return !this.userPasswordForm.dirty || (this.userPasswordForm.value.oldPassword === '' && this.userPasswordForm.value.newPassword === ''
      && this.userPasswordForm.value.repeatNewPassword === '');
  }
}



// WEBPACK FOOTER //
// ./src/app/main/account-setting/user-settings/change-pwd/change-pwd.component.ts